var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"not-found"},[_c('v-icon',{attrs:{"size":_vm.iconSize}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_c('div',{staticClass:"text-center"},[_c('h1',[_vm._v(" 404 ")]),_c('p',[_vm._v(" "+_vm._s(_vm.message)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }